export default
function blocking(state = {
  enabled: true
}, action) {
  switch(action.type) {
    case 'BREAK_LINES':
      return Object.assign({}, state, {
        blocks: action.blocks
      });
    case 'DISABLE_GUIDE':
      return Object.assign({}, state, {
        enabled: false
      });
    case 'ENABLE_GUIDE':
      return Object.assign({}, state, {
        enabled: true
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/guide.js